import { render, staticRenderFns } from "./DataProtection.vue?vue&type=template&id=99cee0c8&"
import script from "./DataProtection.vue?vue&type=script&lang=ts&"
export * from "./DataProtection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports